import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Img from "gatsby-image"

const InstagramWidget = () => (
  <StaticQuery
    query={graphql`
      query InstagramPosts {
        allInstagramContent(limit: 3) {
          edges {
            node {
              link
              localImage {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <section id="instagram_section" className="instagram_section py-24">
        <div className="container mx-auto">
          <div class="flex lg:flex-no-wrap flex-wrap mb-4">
            <div class="lg:w-1/4 w-full instagram_content m-5">
              <p>
                <span>Follow us</span> on
              </p>
              <ul className="flex items-center text-lg font-semibold">
                <li>
                  <a className="text-instagramRed" href="#">
                    Instagram.
                  </a>
                </li>
              </ul>
            </div>
            <div className="lg:w-3/4 w-full">
              <div className="flex flex-wrap">
                {data.allInstagramContent.edges.map((item, i) =>
                  item.node.localImage ? (
                    <div className="lg:w-1/3 w-full  instagram-image" key={i}>
                      <a
                        href={item.node.link}
                        target="_blank"
                        rel="noopener"
                        tabIndex="0"
                      >
                        <div className="m-10">
                          <Img
                            fluid={item.node.localImage.childImageSharp.fluid}
                          />
                        </div>
                      </a>
                    </div>
                  ) : (
                    <div></div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    )}
  />
)

export default InstagramWidget
